import React, { useEffect, useState } from 'react';
import { getService } from '../../reducers/service';
import Content from 'Settings/Content';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Grid, TextField, Box, Divider, InputAdornment } from '@material-ui/core';
import { notify } from 'reducers/NotifierReducer';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';

import { useDispatch,connect } from 'react-redux';
import Checkbox2 from 'components/Checkbox2';
import { ColCard, Row, RowInner } from 'utils/formStyles';
import FormDivider from 'components/FormDivider';
import { Tooltip } from '@mui/material';
import { InfoSignIcon } from 'evergreen-ui';
import { getPasswordValidation, getSessionSettings } from 'reducers/ConfigReducer';

const intitailJson = {
  MOBILE: { required: false, deviceType: 'ALL' },
  CAD: { required: false, deviceType: 'ALL' },
  RMS: { required: false, deviceType: 'ALL' },
  SETTINGS: { required: false, deviceType: 'ALL' },
  ANALYTICS: { required: false, deviceType: 'ALL' },
  ARCHIVE: { required: false, deviceType: 'ALL' },
  AMS: { required: false, deviceType: 'ALL' },
};
const TwoFactorAuth = (props) => {
  const [agencyOptions, setAgencyOptions] = useState([]);
  const [AgencyID, setAgencyID] = useState('');
  const [passwordMinLength, setPasswordMinLength] = useState(8);
  const [passwordMinLengthEditMode, setPasswordMinLengthEditMode] = useState(false);
  const [passwordAttempLimit, setPasswordAttempLimit] = useState(3);
  const [passwordAttempLimitEditMode, setPasswordAttempLimitEditMode] = useState(false);
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [showSessionPopupEditMode, setShowSessionPopupEditMode] = useState(false);
  const [sessionWarningMinutes, setSessionWarningMinutes] = useState(5);
  const [sessionWarningMinutesEditMode, setSessionWarningMinutesEditMode] = useState(false);
  const [applicationJson, setApplicationJson] = useState(intitailJson);
  const cdrService = getService('cdr');
  const isPasswordLengthError =
    passwordMinLength === '' ||
    passwordMinLength < 8 ||
    passwordMinLength > 128;
  
    const isAttemptError =
    passwordAttempLimit === '' ||
    passwordAttempLimit < 3;

  const isSessionMinutesError =
    showSessionPopup &&
    (sessionWarningMinutes === '' || sessionWarningMinutes < 1 || sessionWarningMinutes > 30);

  const isSaveDisabled =
    isPasswordLengthError || isAttemptError || isSessionMinutesError;
   
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.wsClient.websocket) {
      searchPasswordSettings();
    }
  }, [props.dictionary, props.wsClient]);

  const searchPasswordSettings = async () => {
    await getCDRValue('Password.MinLength', 'PasswordValidation', setPasswordMinLengthEditMode, setPasswordMinLength);
    await getCDRValue('Password.MaxAttempt', 'PasswordValidation', setPasswordAttempLimitEditMode, setPasswordAttempLimit);
    await getCDRValue('Session.Warning.Enabled','SessionSettings',setShowSessionPopupEditMode,setShowSessionPopup, true);
    await getCDRValue('Session.Warning.Minutes', 'SessionSettings', setSessionWarningMinutesEditMode, setSessionWarningMinutes);
  };
  
  const handleSaveClick = async () => {
    try {
      if (AgencyID) {
        const service = getService('ptsagencies');
        const data = JSON.stringify(applicationJson);
        const result = await service.patch(AgencyID, {
          TwoFactorAuth: data,
        });
      }
      await handlePasswordSettingSave();
      await dispatch(getPasswordValidation());
      await dispatch(getSessionSettings());
      dispatch(notify('Settings Saved.', 'success'));
    } catch (err) {
      dispatch(notify('Could not Saved.', 'error'));
    }

    // console.log('res of patch ', result);
    //setTwoFactorAuth(result?.data?.TwoFactorAuth);
  };

  const getCDRValue = async (path, key, setEditMode, setValue, isBoolean = false) => {
    const data = await cdrService.get({ Path: path, CDRKey: key });
    const item = data?.[0];
    if (!item) return;

    setEditMode(true);

    if (isBoolean) {
      setValue(Boolean(item.ValueBoolean));
    } else {
      setValue(item.ValueNumeric ?? 0);
    }
  };
  
  const saveCDR = (edit, Path, CDRKey, value, type = 'numeric') => {
    const payload = { Path, CDRKey };
    if (type === 'boolean') {
      payload.ValueBoolean = value;
    } else {
      payload.ValueNumeric = value;
    }
    return edit ? cdrService.patch(null, payload) : cdrService.create(payload);
  };
  
  const handlePasswordSettingSave = async () => {
    try {
      await saveCDR(
        passwordMinLengthEditMode,
        'Password.MinLength',
        'PasswordValidation',
        +passwordMinLength
      );
      await saveCDR(
        passwordAttempLimitEditMode,
        'Password.MaxAttempt',
        'PasswordValidation',
        +passwordAttempLimit
      );
      await saveCDR(
        showSessionPopupEditMode,
        'Session.Warning.Enabled',
        'SessionSettings',
        showSessionPopup,
        'boolean'
      );
      await saveCDR(
        sessionWarningMinutesEditMode,
        'Session.Warning.Minutes',
        'SessionSettings',
        +sessionWarningMinutes
      );
  
    } catch (err) {
      props.handleError(err, 'Error Saving Settings.');
    }
  };
  
  const onChangeAgency = async AgencyID => {
    if (!AgencyID) {
      setAgencyID(null);
      setApplicationJson({ ...intitailJson }); 
      return;
    }
    const service = getService('ptsagencies');
    const result = await service.get(AgencyID);
    const jsonData = JSON.parse(result?.TwoFactorAuth || '{}');
    // console.log('jsonData', jsonData);
    const newObj = {};

    Object.entries(jsonData).forEach(([key, value]) => {
      newObj[key] = {
        required: !!value.required,
        deviceType: value.deviceType || 'ALL',
      };
    });

    setApplicationJson({ ...intitailJson, ...newObj });

    setAgencyID(AgencyID);
  };

  useEffect(() => {
    const fetchAgencies = async () => {
      const service = getService('ptsagencies');
      const response = await service.find({ query: { IsDeleted: false, $limit: 0 } });
      const newArray = response?.data.map(el => el?.AgencyID);
      setAgencyOptions(newArray);
    };
    fetchAgencies();
  }, []);

  const handleCheckbox = (event, key) => {
    setApplicationJson(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        required: event.target.checked
      }
    }));
  };
  const handleDeviceType = (key, value) => {
    setApplicationJson(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        deviceType: value
      }
    }));
  };  
  const renderSave = () => {
    return (
      <div style={{ textAlign: 'right' }} className="mb-2">
        <Button onClick={handleSaveClick} variant="contained" color="primary" disabled={isSaveDisabled}>
          <SaveIcon className="mr-2" /> Save
        </Button>
      </div>
    );
  };
  const renderPasswordLength = () => {
    return (
      <TextField
      fullWidth  
        id="outlined-password-length"
        label="Password minimum length"
        variant="outlined"
        size="small"
        type="number"
        value={passwordMinLength}
        error={isPasswordLengthError}
        helperText={isPasswordLengthError ? 'Password Length must be between 8–128' : ''}
        onKeyPress={e => ['-', '+', '.'].includes(e.key) && e.preventDefault()}
        onChange={e => setPasswordMinLength(e.target.value === '' ? '' : Number(e.target.value))}
        inputProps={{ min: 8, max: 128 }}
      />
    );
  };

  const renderAttemptAllowance = () => {
    return (
      <TextField
        fullWidth
        id="outlined-password-attempt"
        label="Password attempts allowance"
        variant="outlined"
        size="small"
        type="number"
        value={passwordAttempLimit}
        error={isAttemptError}
        helperText={isAttemptError ? 'Password attempt must be greater than 2' : ''}
        onKeyPress={e => ['-', '+', '.'].includes(e.key) && e.preventDefault()}
        onChange={e => setPasswordAttempLimit(e.target.value === '' ? '' : Number(e.target.value))}
        inputProps={{ min: 3 }}
      />
    );
  };
  // console.log('applicationJson', applicationJson);
  return (
    <Content>
      <div className="m-4">
        {renderSave()}
        <Row>
          <ColCard minWidth={500}>
            <FormDivider title="Two Factor Authentication" />
            <Grid container spacing={4} className="my-2">
              <Grid item xs={12} sm={12}>
                <Box>
                  <Autocomplete
                    size="small"
                    options={agencyOptions}
                    value={AgencyID}
                    renderInput={params => (
                      <TextField {...params} label="Agency" variant="outlined" />
                    )}
                    onChange={(event, selection) => onChangeAgency(selection || null)}
                  />
                </Box>
              </Grid>
              {Object.entries(applicationJson).map(([key, value]) => (
                <Grid item xs={12} sm={12} key={key} style={{ paddingTop: '5px' }}>
                  <Grid container>
                    <Grid item xs={12} sm={3}>
                      <Box>
                        <Checkbox2
                          size="small"
                          checked={value.required}
                          disabled={!AgencyID}
                          onChange={e => handleCheckbox(e, key)}
                          label={key}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Box>
                        <Autocomplete
                          size="small"
                          disabled={!AgencyID || !value.required}
                          options={['MOBILE', 'ALL']}
                          value={value.deviceType}
                          renderInput={params => (
                            <TextField {...params} label="Device Type" variant="outlined" />
                          )}
                          onChange={(event, selection) => {
                            handleDeviceType(key, selection);
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </ColCard>
          <ColCard minWidth={500}>
            <div>
              <FormDivider title="Password settings" />
              <Grid container spacing={4} alignItems="center" className="my-2">
                <Grid item xs={5}>
                  <Box>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                      Password minimum length
                      <Tooltip title="Minimum number of characters required for a user's password. Must be between 8 and 128 characters.">
                        <InfoSignIcon
                          style={{ fontSize: 20, color: '#178CEA', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={7}>
                  {renderPasswordLength()}
                </Grid>

                <Grid item xs={5}>
                  <Box>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                      Password attempt allowance
                      <Tooltip title="Number of times a user can attempt to log in before the account is locked out.">
                        <InfoSignIcon
                          style={{ fontSize: 20, color: '#178CEA', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={7}>
                  {renderAttemptAllowance()}
                </Grid>
              </Grid>
              <FormDivider title="Session Expiry Settings" />
              <Grid container spacing={4} alignItems="center" className="my-2">
                <Grid item xs={5} className="py-0">
                  <Checkbox2
                    size="small"
                    checked={showSessionPopup}
                    onChange={e => setShowSessionPopup(e.target.checked)}
                    label="Enable Session Expiry Warning"
                    tooltipText="Number of minutes before session expiry when the renewal popup will be displayed. Must be between 1 and 30 minutes."
                  />
                </Grid>
                {showSessionPopup && (
                  <Grid item xs={7}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      variant="outlined"
                      label="Show Warning Before Expiry"
                      value={sessionWarningMinutes}
                      error={isSessionMinutesError}
                      helperText={
                        isSessionMinutesError ? 'Value must be between 1 and 30 minutes' : ''
                      }
                      onKeyPress={e => ['-', '+', '.'].includes(e.key) && e.preventDefault()}
                      onChange={e =>
                        setSessionWarningMinutes(
                          e.target.value === '' ? '' : Number(e.target.value)
                        )
                      }
                      InputProps={{
                        inputProps: { min: 1, max: 30 },
                        endAdornment: <InputAdornment position="start">Minutes</InputAdornment>,
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </div>
          </ColCard>
        </Row>
      </div>
    </Content>
  );
};
const mapStateToProps = state => {
  return {
    wsClient: state.websocket,
  };
};

export default connect(mapStateToProps)(TwoFactorAuth);
